import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { convertUTCToLocalDate } from 'utils/date-util'
import { Card, CardContent, CardTitle } from './cardStyles'
import { getDocName } from 'hooks/useDocListData'
import DocumentUploaded from 'images/documentUploaded'
import DocumentUploadEdit from 'images/documentUploadEdit'
import { MESSAGES } from '../../messages/messages'

const CompletedCard = ({
    id,
    documentStatusUpdatedTimeStamp,
    selectFile = () => {},
    onKeyDownHandler = () => {},
    ...props
}) => {
    const documentName = getDocName(props)

    return (
        <Card
            tabIndex={0}
            data-testid={id}
            sx={{
                border: (theme) => `1px solid ${theme.palette.success.main}`,
                justifyContent: 'center',
                borderRadius: 4,
                padding: 4,
                boxShadow: '0'
            }}
            onClick={selectFile}
            onKeyDown={onKeyDownHandler}
        >
            <Box
                sx={{
                    display: 'grid',
                    justifyItems: 'start'
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        width: '100%',
                        gridAutoFlow: 'column',
                        gap: 1,
                        lineHeight: '0'
                    }}
                >
                    <CardContent
                        sx={{
                            alignItems: 'flex-start'
                        }}
                    >
                        <Box
                            aria-hidden="true"
                            role="img"
                            aria-label="success icon"
                            data-testid="action-success"
                            sx={{
                                color: 'primary.main',
                                p: 0,
                                textAlign: 'right'
                            }}
                        >
                            <DocumentUploaded />
                        </Box>
                        <Box>
                            <CardTitle
                                sx={{
                                    typography: 'mediumBody2',
                                    letterSpacing: '0',
                                    paddingBottom: 1
                                }}
                                data-testid="document-name"
                            >
                                {documentName}
                            </CardTitle>

                            <Typography
                                color="common.charcoal.main"
                                component="span"
                                data-testid="document-status"
                                sx={{
                                    typography: 'regularBody3',
                                    letterSpacing: 0,
                                    backgroundColor: 'common.gray.think',
                                    padding: 1,
                                    borderRadius: 1
                                }}
                            >
                                {MESSAGES.COMPLETED_DESC}&nbsp;
                                {convertUTCToLocalDate(documentStatusUpdatedTimeStamp, {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit'
                                })}
                            </Typography>
                        </Box>
                    </CardContent>
                    <Box
                        aria-hidden="true"
                        role="img"
                        aria-label="edit icon"
                        data-testid="action-edit"
                        sx={{
                            color: 'primary.main',
                            p: 0,
                            textAlign: 'right'
                        }}
                    >
                        <DocumentUploadEdit />
                    </Box>
                </Box>
            </Box>
        </Card>
    )
}

CompletedCard.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    documentStatusUpdatedTimeStamp: PropTypes.string,
    selectFile: PropTypes.func,
    onKeyDownHandler: PropTypes.func
}

export default CompletedCard
